<template>
  <div></div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";

import { BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  data() {
    return {
      interval: "",
      dashboard: {
        highlights: {
          users: 0,
          solicitations: 0,
          in_approve: 0,
          waiting_programming: 0,
          solicitations_f: 0,
        },
      },
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
  },
  methods: {
    getDashboard() {},
  },
  destroyed() {
    clearInterval(this.interval);
    console.log("destroyed");
  },
  mounted() {
    const self = this;

    self.getDashboard();

    let intervl = 0;

    setTimeout(function () {
      while (intervl < 1000) {
        clearInterval(intervl);
        console.log("limpando intervals");
        intervl++;
      }
    }, 1000);

    if (self.interval == "") {
      self.interval = setInterval(function () {
        self.getDashboard();
      }, 10000);
    }

    // Echo.private("user.1").listen(".Alert", (data) => {
    //   console.log(data);
    // });
  },
  created() {},
};
</script>

<style></style>
